import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowRedirectService {
  public static openUrlInNewTab(relativePath: string): void {
    const formattedRelativePath = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;

    window.open(`${this.getBaseUrl()}${formattedRelativePath}`, '_blank');
  }

  public static getBaseUrl(): string {
    return `${window.location.origin}${this.getRootPath()}`;
  }

  public static getRootPath(): string {
    return '/campaign-dashboard';
  }
}
